import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

interface LayoutProps { children: React.ReactNode; }

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true); // desktop default
  const [isMobileOpen, setMobileOpen] = useState(false);  // mobile drawer

  return (
    <div className="flex h-screen">
      {/* Sidebar (hem mobil drawer hem desktop) */}
      <Sidebar
        isOpen={isSidebarOpen}
        mobileOpen={isMobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Mobile overlay */}
      {isMobileOpen && (
        <button
          aria-label="Menü arkaplan"
          onClick={() => setMobileOpen(false)}
          className="fixed inset-0 z-30 bg-black/40 md:hidden"
        />
      )}

      {/* Content */}
      <div className="flex-1 flex flex-col min-w-0">
        <Header
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={() => setSidebarOpen(s => !s)}
          openMobile={() => setMobileOpen(true)}
        />
        <main className="flex-1 bg-gray-100 p-3 md:p-6 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
